import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  collection,
  getDocs,
  query,
  orderBy,
} from 'firebase/firestore';
import { db } from '../firebase';

export default function RentalGuidelinesLog() {
  const [logs, setLogs] = useState([]);
  const [search, setSearch] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const entriesRef = collection(db, 'logs', 'rentalGuidelines', 'entries');
        const q = query(entriesRef, orderBy('timestamp', 'desc'));
        const snapshot = await getDocs(q);
        const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setLogs(data);
      } catch (error) {
        console.error('Error fetching guideline logs:', error);
      }
    };

    fetchLogs();
  }, []);

  const filtered = logs.filter(
    log =>
      log.userId?.toLowerCase().includes(search.toLowerCase()) ||
      log.bookingId?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div style={styles.container}>
      <button onClick={() => navigate('/dashboard')} style={styles.backButton}>
        ← Back to Dashboard
      </button>
      <h2 style={styles.title}>📘 Rental Guidelines Acknowledgments</h2>

      <input
        type="text"
        placeholder="Search by User ID or Booking ID"
        value={search}
        onChange={e => setSearch(e.target.value)}
        style={styles.search}
      />

      <div style={styles.tableWrapper}>
        {filtered.length === 0 ? (
          <p style={styles.noData}>No matching entries found.</p>
        ) : (
          <table style={styles.table}>
            <thead style={styles.thead}>
              <tr>
                <th style={styles.th}>User ID</th>
                <th style={styles.th}>Booking ID</th>
                <th style={styles.th}>Category</th>
                <th style={styles.th}>Don’t Show Again</th>
                <th style={styles.th}>Timestamp</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(log => (
                <tr key={log.id} style={styles.tr}>
                  <td style={styles.td}>{log.userId}</td>
                  <td style={styles.td}>{log.bookingId}</td>
                  <td style={styles.td}>{log.category || 'Unknown'}</td>
                  <td style={styles.td}>{log.dontShowAgain ? '✅' : '—'}</td>
                  <td style={styles.td}>
                    {log.timestamp?.toDate().toLocaleString() || '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: {
    padding: '2rem',
    fontFamily: 'system-ui, sans-serif',
    backgroundColor: '#f9f9f9',
    minHeight: '100vh',
  },
  backButton: {
    backgroundColor: '#eeeeee',
    border: '1px solid #ccc',
    padding: '0.5rem 1rem',
    borderRadius: '6px',
    cursor: 'pointer',
    fontWeight: 500,
    marginBottom: '1rem',
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 600,
    color: '#065f46',
    marginBottom: '1rem',
  },
  search: {
    marginBottom: '1.5rem',
    padding: '0.5rem',
    fontSize: '0.95rem',
    width: '100%',
    maxWidth: '360px',
    border: '1px solid #ccc',
    borderRadius: '6px',
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    backgroundColor: '#fff',
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
  },
  thead: {
    backgroundColor: '#f1f5f9',
    textAlign: 'left',
  },
  th: {
    padding: '12px',
    fontWeight: 600,
    borderBottom: '1px solid #ddd',
    fontSize: '0.9rem',
  },
  td: {
    padding: '12px',
    borderBottom: '1px solid #eee',
    fontSize: '0.875rem',
  },
  tr: {
    backgroundColor: '#fff',
  },
  noData: {
    color: '#888',
    fontSize: '0.95rem',
  },
};
